import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import Popover from "@hydrologiq/shared/chakra/Popover"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"
import AssetCreationForm from "@hydrologiq/shared/components/creation/AssetCreationForm"
import { emitSectionEvent, SECTION_EVENTS } from "@hydrologiq/shared/hooks/useSectionEvent"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

interface AssetCreateProps {
  onAssetCreated?: () => void | Promise<void>
}

const AssetCreate = ({ onAssetCreated }: AssetCreateProps) => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const route = useRoute()

  const copy = useCopyValues({
    [COPY_KEYS.HEADINGS.ASSET]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET],
    [COPY_KEYS.FORMS.PLEASE_PROVIDE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_PROVIDE],
    [COPY_KEYS.FORMS.INFORMATION_BELOW]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.INFORMATION_BELOW],
  })

  const handleSuccess = async (asset: gqlTypes.Asset) => {
    setOpen(false)

    // Notify other sections that a new asset was created
    emitSectionEvent(SECTION_EVENTS.ASSET_CREATED)

    // Navigate to the created asset's page
    const assetPath = `${route.endsWith("/") ? route : route + "/"}${asset.id}`
    navigate(assetPath)

    // Optionally refresh the list for better UX
    if (onAssetCreated) {
      await onAssetCreated()
    }
  }

  const handleCancel = () => {
    setOpen(false)
  }

  return (
    <Popover
      actionType="create"
      actionVariant="primary"
      placement="right-end"
      loading={false}
      onOpenChange={setOpen}
      open={open}
    >
      <AssetCreationForm
        heading={copy[COPY_KEYS.HEADINGS.ASSET]}
        helperText={`${copy[COPY_KEYS.FORMS.PLEASE_PROVIDE]} ${copy[COPY_KEYS.HEADINGS.ASSET].toLowerCase()} ${
          copy[COPY_KEYS.FORMS.INFORMATION_BELOW]
        }.`}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Popover>
  )
}

export default AssetCreate
